import { __rest } from "tslib";
import * as React from 'react';
import { Tooltip } from '@patternfly/react-core';
import { css } from '@patternfly/react-styles';
export const CatalogTileBadge = (_a) => {
    var { children = null, className = '', id = null, title = null } = _a, props = __rest(_a, ["children", "className", "id", "title"]);
    const classes = css('catalog-tile-pf-badge', className);
    if (title) {
        return (React.createElement(React.Fragment, null,
            React.createElement(Tooltip, { id: id, content: title },
                React.createElement("span", Object.assign({ className: classes }, props),
                    children,
                    React.createElement("span", { className: "sr-only" }, title)))));
    }
    return (React.createElement("span", Object.assign({ className: classes }, props), children));
};
CatalogTileBadge.displayName = 'CatalogTileBadge';
//# sourceMappingURL=CatalogTileBadge.js.map